import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var HomeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(HomeComponent, _super);
    function HomeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = 'Home page';
        return _this;
    }
    return HomeComponent;
}(AbstractPageComponent));
export { HomeComponent };
